import React, { useEffect, useState } from "react";
import Table from "./../../Components/Table";
import useFetch from "../../Hooks/useFetch";
import useSave from "../../Hooks/useSave";
import useUpdate from "../../Hooks/useUpdate";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import useValidateRole from "../../Hooks/useValidateRole";
const BankAccountsApproval = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setview] = useState(false);
    const [Decline, setDecline] = useState(false);
    const [PageRole, setPageRole] = useState("Bank Accounts Approval");
   
    const url = "api/BankAccounts/PendingApproval";
    const { state, FetchAll } = useFetch(url);

  

    useEffect(() => {
        FetchAll();
    }, []);   
  
    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };
    
    const handleDecline = () => {
        if (inputs.id) {
            setOpen(true);
            setDecline(true);
            setview(false);
        } else {
            alert("Select a record to edit");
        }
    };
    const handleApprove = () => {
        if (inputs.id) {
            setOpen(true);
            setDecline(false);
            setview(false);
        } else {
            alert("Select a record to edit");
        }
    };
    const handleView = () => {
        if (inputs.id) {
            setview(true);
            setOpen(true);
        } else {
            alert("Select a record to veiw");
        }
    };
    const handleSelect = (k, event) => {
        setInputs({});
        setInputs(k);
    };
    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setview(false);
        setDecline(false);
    };
  
    const HandleUpdate = () => {
        let data={
            BankAccountsId: inputs.id ,
            Remarks:inputs.remarks,
            Action:Decline?"Decline":"Approve"
        }
        let approvalurl="api/BankAccounts/approve";
        useSave(approvalurl, data);
        setTimeout(() => {
            FetchAll();
        }, 2000)

    };
    const HandleSubmit = (event) => {
        event.preventDefault();      
        HandleUpdate();       
        setOpen(false);
    };
 
    const ColumnData = [
        {
            label: "institution",
            field: "institution",
            sort: "asc",
        }, {
            label: "AccountNumber",
            field: "accountNumber",
            sort: "asc",
        }, {
            label: "accountName",
            field: "accountName",
            sort: "asc",
        }, {
            label: "Bank",
            field: "bank",
            sort: "asc",
        },
        {
            label: "Branch",
            field: "bankBranch",
            sort: "asc",
        },
        {
            label: "Status",
            field: "status",
            sort: "asc",
        },
        {
            label: "ApprovalStatus",
            field: "approvalStatus",
            sort: "asc",
        },
    ];
    let Rowdata1 = [];
    const rows = state.data;

    if (rows.length > 0) {
        rows.forEach((k) => {
            const Rowdata = {
                clickEvent: () => handleSelect(k),
                accountNumber: k.accountNumber,
                status: k.status,
                approvalStatus: k.approvalStatus,
                accountName: k.accountName,
                bank: k.bank ? k.bank.name : "",
                institution: k.institution ? k.institution.name : "",
                bankBranch: k.bankBranch ? k.bankBranch.name : "",
            };
            Rowdata1.push(Rowdata);
        });
    }

    const ActionsBtn = () => {
        return (
            <div>
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleApprove}
                    >
                        Approve
                    </button>
                ) : null}&nbsp;&nbsp;
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-danger p-2"
                        type="button"
                        onClick={handleDecline}
                    >
                        Decline
                    </button>
                ) : null}
      
        &nbsp;&nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
        </button>
            </div>
        );
    };
    return (
        <div id="content" className="content">
            <ol class="breadcrumb float-xl-right">
                <li class="breadcrumb-item">
                    {" "}
                    <Link to="/">Home </Link>{" "}
                </li>
                <li class="breadcrumb-item active">Bank Account</li>
            </ol>
            <h1 class="page-header mb-3">Bank Account Approval</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div class="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
           
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleApprove}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Approve &nbsp;
                            </button>
                        ) : null}
                         {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleDecline}
                                className="btn btn-danger p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Decline &nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={Rowdata1} columns={ColumnData} />
                    </div>
                </div>
            </div>

            <Modal visible={open} width="65%" height="50%" effect="fadeInUp">
                <div style={{ "overflow-y": "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
          </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 fontWeight-bold text-blue">
                                Bank Account Approval
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />

                                {view ? (
                                    <div>
                                        <h3>Bank Branch</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Institution:</td>
                                                    <td>{inputs.institution?inputs.institution.name:""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Name:</td>
                                                    <td>{inputs.accountNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Account Name:</td>
                                                    <td>{inputs.accountName}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Bank:</td>
                                                    <td>{inputs.bank ? inputs.bank.name : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Branch:</td>
                                                    <td>{inputs.bank ? inputs.bankBranch.name : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Status:</td>
                                                    <td>{inputs.status}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div
                                            style={{ display: "flex", "justify-content": "flex-end" }}
                                        >
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                         <div className=" row">
                                         <div className="col-sm">
                        <div className="form-group">
                        <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                           {Decline?"Decline Bank Account ":"Approve Bank Account "} Remarks
                          </label> 
                          <textarea
                                                            type="text"
                                                            className="form-control"
                                                            name="remarks"
                                                            required
                                                            value={inputs.remarks}
                                                            onChange={handleInputChange}
                                                        // defaultvalue={inputs.name}
                                                        />
                        </div>
                      </div>
                                            
                                             </div>

                                        <div
                                            style={{ display: "flex", "justify-content": "flex-end" }}
                                        >
                                            <div class="d-flex flex-row">
                                               
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                
                        &nbsp;
                        <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                        </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default BankAccountsApproval;
